import { useEffect, useRef } from "react";

export default function useRingingSound(active) {
  const ctxRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!active) {
      if (ctxRef.current) {
        ctxRef.current.close();
        ctxRef.current = null;
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      return;
    }

    let ctx;
    try {
      ctx = new (window.AudioContext || window.webkitAudioContext)();
    } catch {
      return;
    }
    ctxRef.current = ctx;

    const playRing = () => {
      if (!ctxRef.current) return;
      const now = ctxRef.current.currentTime;

      [440, 480].forEach((freq) => {
        const osc = ctxRef.current.createOscillator();
        const gain = ctxRef.current.createGain();
        osc.type = "sawtooth";
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.5, now);
        gain.gain.exponentialRampToValueAtTime(0.01, now + 0.4);
        osc.connect(gain);
        gain.connect(ctxRef.current.destination);
        osc.start(now);
        osc.stop(now + 0.4);
      });

      timeoutRef.current = setTimeout(playRing, 600);
    };

    const resumeCtx = () => {
      if (ctx.state === "suspended") {
        ctx.resume().then(playRing).catch(() => setTimeout(resumeCtx, 500));
      } else {
        playRing();
      }
    };

    resumeCtx();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      if (ctxRef.current) {
        ctxRef.current.close();
        ctxRef.current = null;
      }
    };
  }, [active]);
}
